module.exports = __webpack_public_path__ + "static/rucar-1-4a15f0d22b36062782edeacbe1987d1e.jpg";